import { render } from "./TheCounts.vue?vue&type=template&id=396d3b15"
import script from "./TheCounts.vue?vue&type=script&lang=js"
export * from "./TheCounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__